<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
      </div>
      <Navbar></Navbar>
    </aside>
    
    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Top Navbar -->
      <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
        <h2 class="text-xl font-semibold">Support</h2>
      </header>
      
      <!-- Support Page Content -->
      <main class="p-6 flex-1">
        <div class="bg-gray-800 p-6 rounded-xl shadow-md">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">Support Tickets</h3>

            <!-- Search Input -->
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search tickets..."
              class="px-3 py-2 rounded-md bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring focus:ring-blue-500"
            />
          </div>

          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-700">
                <th class="p-3 rounded-tl-lg">Ticket ID</th>
                <th class="p-3">Subject</th>
                <th class="p-3">Priority</th>
                <th class="p-3">Status</th>
                <th class="p-3 rounded-tr-lg">Last Updated</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="ticket in filteredTickets"
                :key="ticket.id"
                class="border-t border-gray-700 hover:bg-gray-600 transition cursor-pointer"
                @click="goToTicket(ticket.id)"
              >
                <td class="p-3 font-semibold">#{{ ticket.id }}</td>
                <td class="p-3">{{ ticket.subject }}</td>
                <td class="p-3">{{ ticket.priority }}</td>
                <td class="p-3">
                  <span :class="statusClass(ticket.status)" class="px-2 py-1 rounded-lg">
                    {{ ticket.status }}
                  </span>
                </td>
                <td class="p-3">{{ ticket.date || "Just Now" }}</td>
              </tr>

              <!-- No results row -->
              <tr v-if="filteredTickets.length === 0">
                <td colspan="5" class="p-3 text-center text-gray-400">
                  No tickets found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios';

export default {
  name: "CloudSupport",
  components: { Navbar },
  data() {
    return {
      tickets: [],
      newTicket: { subject: "", priority: "Low", description: "" },
      searchQuery: ""
    };
  },
  computed: {
    filteredTickets() {
      if (!this.searchQuery) return this.tickets;
      const query = this.searchQuery.toLowerCase();
      return this.tickets.filter(ticket =>
        String(ticket.id).includes(query) ||
        (ticket.subject && ticket.subject.toLowerCase().includes(query)) ||
        (ticket.priority && ticket.priority.toLowerCase().includes(query)) ||
        (ticket.status && ticket.status.toLowerCase().includes(query)) ||
        (ticket.date && ticket.date.toLowerCase().includes(query))
      );
    }
  },
  methods: {
    async fetchTickets() {
      try {
        const response = await axios.get(
          'https://api.syniac.com:3000/api/admin/ticket/tickets',
          { withCredentials: true }
        );
        this.tickets = response.data.tickets;
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
    },
    goToTicket(ticketID) {
      this.$router.push(`/admin/view_ticket/${ticketID}`);
    },
    statusClass(status) {
      return status === "Open"
        ? "bg-green-500 text-white px-2 py-1 rounded"
        : "bg-gray-500 text-white px-2 py-1 rounded";
    }
  },
  mounted() {
    this.fetchTickets();
  }
};
</script>
